var version = {
    "name":      "dativery",
    "buildDateCode": "20260608-110025",
    "buildDate": "Mon Jun 08 2026 11:00:25 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260608-110025",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;